export const SUPPORTED_LOCALES = ['en', 'ar'];

export const TRANSLATIONS = {
  en: {
    voice: {
      start: 'Speak your prompt', stop: 'Stop dictation', cancel: 'Cancel microphone', finishing: 'Finishing…',
      languageLabel: 'Dictation language',
      privacy: 'Uses your browser’s speech service, which may process audio online.',
      unsupported: 'Voice input isn’t supported in this browser. Try Chrome or Safari, or use your device’s dictation.',
      starting: 'Waiting for microphone access…', listening: 'Listening… Speak naturally, then press Stop.',
      stopping: 'Finishing your transcript…', added: 'Voice input added. Review your prompt before generating.',
      permission: 'Microphone access was denied. Allow it in your browser’s site settings, then try again.',
      service: 'This browser’s speech service is unavailable. Try opening this page in Chrome or Safari.',
      microphone: 'No microphone is available. Check your microphone connection and system permissions.',
      network: 'Couldn’t reach the browser’s speech service. Check your connection or try Chrome or Safari.',
      noSpeech: 'No speech was captured. Try again and speak clearly, or keep typing.',
      language: 'This speech service doesn’t support the selected language. Try the other language or keep typing.',
      startTimeout: 'Voice input couldn’t start. Check microphone permissions or try another browser.',
      failed: 'Voice input couldn’t start. Please try again or keep typing.',
    },
    rewrite: {"action": "Rewrite with AI", "busy": "Rewriting…", "style": "Rewrite style", "polish": "Improve", "shorten": "Shorten", "expand": "Add detail", "professional": "Professional", "working": "Improving your text. Your original stays unchanged.", "suggestion": "AI suggestion", "review": "Review or edit the suggestion, then choose whether to use it.", "discard": "Keep original", "apply": "Use this version", "error": "Could not rewrite right now. Please try again. Your original text is unchanged."},
    studio: {
      "eyebrow": "A LITTLE IDEA. ENDLESS POSSIBILITIES.",
      "title": "Make something",
      "titleAccent": "remarkable.",
      "description": "Your brand, in every frame. Turn an idea into images, videos, audio, and words.",
      "activeBrand": "YOUR BRAND SPACE",
      "brief": "01 / THE IDEA",
      "briefTitle": "What are we creating?",
      "inspiration": "Need a starting point?",
      "characters": "characters",
      "shortcut": "⌘ / Ctrl + Enter to generate",
      "settings": "Fine-tune your creation",
      "canvas": "The canvas",
      "canvasCaption": "A space for your next great idea",
      "emptyTitle": "From a spark to something special.",
      "emptyHint": "Write your brief, make it yours, and hit Generate. Your creation will appear here.",
      "ready": "Ready when you are",
      "brandAware": "Your brand, built in",
      "exportReady": "Made to share",
      "historyEmpty": "A fresh start. Your creations will collect here.",
      "imageOne": "Product spotlight",
      "imageTwo": "Social campaign",
      "imageThree": "Editorial scene",
      "videoOne": "Product reveal",
      "videoTwo": "Brand story",
      "videoThree": "Cinematic loop",
      "textOne": "Social caption",
      "textTwo": "Product launch",
      "textThree": "Brand story",
      "audioOne": "Welcome message",
      "audioTwo": "Launch teaser",
      "audioThree": "Brand introduction",
      "promptDetails": "Prompt details",
      "previewShortcut": "View creation"
},
    app: {
      title: 'Brand Studio',
      subtitle: 'CodeFalcon Projects • Brand content studio',
      footer: 'Made with luv in Syria • A CodeFalcon project',
      heroKicker: 'Create on-brand content in minutes',
      heroTitleA: 'Make anything.',
      heroTitleB: 'Brand louder.',
      heroBody:
        'A full-featured studio for images, video, audio, and text. Upload your logo to extract colors and export with an exact logo overlay.',
    },
    common: {
      language: 'Language',
      mediaType: 'Media type',
      upload: 'Upload',
      toggleTheme: 'Toggle theme',
      edit: 'Edit',
      remove: 'Remove',
      back: 'Back',
      close: 'Close',
      open: 'Open',
      preview: 'Preview',
      retry: 'Retry',
      download: 'Download',
      downloadAll: 'Download all (ZIP)',
      loading: 'Loading',
      error: 'Error',
      generate: 'Generate',
      generating: 'Generating…',
      settings: 'Settings',
      seed: 'Seed',
      copy: 'Copy',
      copyUrl: 'Copy URL',
      copyOutput: 'Copy output',
      copyText: 'Copy text',
      save: 'Save',
      clear: 'Clear',
    },
    media: { image: 'Image', video: 'Video', text: 'Text', audio: 'Audio' },
    nav: {
      pages: 'Pages',
      studio: 'Studio',
      brandKit: 'Brand kit',
    },
    tabs: {
      prompt: 'Prompt',
      history: 'History ({{count}})',
    },
      brandKit: {
        title: 'Brand kit',
        subtitle: 'Build your brand identity, then generate a full social pack.',
        stepsLabel: 'Brand kit steps',
        settingsTabs: {
          identity: 'Identity',
          pack: 'Pack',
        },
        steps: {
          basics: 'Basics',
          studio: 'Design studio',
          export: 'Export',
        },
        basics: {
          title: 'Brand basics',
        },
        logo: {
          title: 'Logo',
          ready: 'Logo is ready. Palette will stay consistent across your assets.',
          missing: 'Upload a logo to unlock palette extraction and overlays.',
          generate: 'Generate logo',
          generating: 'Generating logo…',
        },
        identity: {
          previewTitle: 'Preview',
          colorsTitle: 'Colors',
          colorsHint: 'You can edit or expand this palette later.',
          fontsTitle: 'Fonts',
        colorPicker: 'Color picker',
        colorHex: 'Color hex',
        addColor: 'Add color',
        colorMode: 'Color mode',
        modeDark: 'Dark',
        modeLight: 'Light',
        regenFromPalette: 'Auto-generate roles',
        rolesTitle: 'Color roles',
        rolesMissing: 'Roles are not set yet. Click Auto-generate roles.',
        locked: 'Locked',
        unlocked: 'Unlocked',
        roleBackground: 'Background',
        roleSurface: 'Surface',
        rolePrimary: 'Primary',
        roleSecondary: 'Secondary',
        roleAccent: 'Accent',
        roleText: 'Text',
        roleTextMuted: 'Muted text',
        roleBorder: 'Border',
        roleTextOnPrimary: 'Text on primary',
        contrastBg: 'Text/Background',
        contrastSurface: 'Text/Surface',
        contrastPrimary: 'Text/Primary',
        previewText: 'Preview of your brand UI. Adjust roles until it feels right.',
        primaryButton: 'Primary',
        secondaryButton: 'Secondary',
        fontArabic: 'Arabic font',
        fontLatin: 'Latin font',
        fontsHint: 'Choose a pairing to keep everything consistent.',
      },
        pack: {
          title: 'Social pack',
          previewTitle: 'Preview',
          hint: 'Tip: start with a profile avatar + 6 highlight covers.',
          livePreviewTitle: 'Instagram live preview',
          liveHint: 'Click the avatar, profile name, bio, highlights, or grid tiles to edit.',
          liveOpenPreview: 'Open preview',
          liveReset: 'Reset edits',
          liveEditTitle: 'Edit image',
          liveEditTextTitle: 'Edit text',
          brandSettingsTitle: 'Brand settings',
          liveInspectorTitle: 'Live editor',
          liveInspectorEmpty: 'Tap something in the preview to edit it.',
          liveEditNow: 'Edit',
          liveEditPick: 'Edit (tap an item)',
          liveUpload: 'Upload',
          liveGenerateAi: 'Generate with AI',
          liveGenerateTextAi: 'Generate text with AI',
          livePromptLabel: 'Prompt',
          livePromptPlaceholder: 'Describe what you want… (no text/letters)',
          livePromptReset: 'Reset prompt',
          livePromptHint: 'Use presets for quick results. Use Custom only if you need something specific.',
          livePromptCustom: 'Custom',
          livePromptUsePresets: 'Use presets',
          livePreset: {
            default: 'Default',
            minimal: 'Minimal',
            illustration: 'Illustration',
            luxury: 'Luxury',
            playful: 'Playful',
          },
          livePickAvatar: 'Change profile picture',
          livePickProfileName: 'Edit profile name',
          livePickBio: 'Edit bio',
          livePickHighlight: 'Change highlight cover: {{label}}',
          livePickGrid: 'Change grid item {{index}}',
          livePickCaption: 'Edit caption for post {{index}}',
          liveNoHighlights: 'Generate highlight covers to edit them here.',
          liveTextValue: 'Text',
          liveCaption: 'Post caption',
          liveCaptionPlaceholder: 'Write a caption…',
          liveGenerateCaptionAi: 'Generate caption',
          liveDone: 'Done',
          includeAvatar: 'Profile avatar',
          includeHighlights: 'Instagram highlight covers',
          includePosts: 'Instagram posts',
          postsTitle: 'Posts',
          postCount: 'Count',
          generateCaptions: 'Generate captions',
          postTopics: 'Post topics',
          postTopicsPlaceholder: 'One topic per line…',
          postTopicsHint: 'First lines are used as topics for each post (extra lines are ignored).',
          generatePostsAi: 'Generate posts with AI',
          artStyle: 'Highlight style',
          artIllustration: 'Illustration',
          artSubLogo: 'Sub-logo',
          highlightLabels: 'Highlight labels',
          addLabel: 'Add label',
          labelPlaceholder: 'Label',
          bilingualHint: 'Use “English | عربي” to set both languages for a label.',
          langEnglish: 'English set',
          langArabic: 'Arabic set',
          regenerateIcons: 'Regenerate icons',
          generateIcon: 'Generate illustration',
          generateSubLogo: 'Generate sub-logo',
          uploadIcon: 'Upload image',
          iconBackdrop: 'Icon background',
          backdropTransparent: 'Transparent',
          backdropSurface: 'Surface',
          backdropPrimary: 'Primary',
        backdropAccent: 'Accent',
        backdropCustom: 'Custom',
        backdropOpacity: 'Background opacity',
        generate: 'Generate pack',
        viewExport: 'View export',
      },
      export: {
        title: 'Export',
        empty: 'Generate a pack to see your assets here.',
        exportAll: 'Export all',
      },
      assets: {
        avatar: 'Avatar',
        post: 'Post {{index}}',
        caption: 'Caption {{index}}',
      },
    },
    promptCard: {
      title: 'Prompt',
      hintImage: 'Describe what you want. The rest is generated from your settings.',
      hintText: 'Ask for what you want written. Brand/settings are applied automatically.',
      hintAudio: 'Write the text you want spoken. Voice/model come from settings.',
      fieldLabelImage: 'What do you want to generate?',
      fieldLabelText: 'Instruction',
      fieldLabelAudio: 'Text to speak',
      placeholderImage: 'Example: A modern restaurant scene, customer scanning a QR code menu, cinematic lighting',
      placeholderText: 'Example: Write a 20-second Instagram Reel script for a restaurant QR menu SaaS, in Arabic.',
      placeholderAudio: 'Example: حوّل قائمة مطعمك إلى QR Menu خلال 24 ساعة',
    },
    generation: {
      eyebrow: 'A LITTLE IDEA, COMING TO LIFE',
      image: 'Creating your image',
      video: 'Creating your video',
      audio: 'Creating your audio',
      text: 'Creating your copy',
      imageHint: 'Finding the right light, color, and composition for your idea.',
      videoHint: 'Good motion takes a moment. Videos can take a few minutes.',
      audioHint: 'Turning your brief into sound. Your audio will appear here.',
      textHint: 'Finding the words that fit your brief and your brand.',
      longWait: 'Taking a little longer. Still waiting for the result — no need to generate again.',
      inProgress: 'Creation in progress',
      elapsed: '{{time}} elapsed',
      keepOpen: 'Keep this tab open. Your result will appear here automatically.',
      viewProgress: 'View progress in the canvas',
      failed: 'Your creation couldn’t finish',
    },
    preview: {
      lockSeed: 'Lock seed',
      generatedAlt: 'Generated',
      loadingTitle: 'Generating…',
      textFailedTitle: 'Failed to generate text',
      loadFailedTitleImage: 'Failed to load image',
      loadFailedTitleVideo: 'Failed to load video',
      loadFailedTitleAudio: 'Failed to load audio',
      emptyTitleImage: 'Your preview appears here',
      emptyTitleText: 'Your text output appears here',
      emptyTitleAudio: 'Your audio output appears here',
      emptyHint: 'Fill the Prompt, then tap Generate.',
      videoWaitHint: 'Video can take 1–3 minutes.',
      logoOverlayAdd: 'Add logo',
      logoOverlayRemove: 'Remove logo',
      logoOverlayTitle: 'Logo overlay',
      instagramOn: 'IG preview',
      instagramOff: 'Normal preview',
      instagramHint: 'Add a caption in Subject to see it here.',
      instagramProfile: 'Profile',
      instagramPost: 'Post',
      instagramStory: 'Story',
    },
    brand: {
      profile: 'Brand profile',
      newBrand: 'New brand',
      untitled: 'Untitled brand',
      useProfile: 'Use brand profile (colors + style consistency)',
      new: 'New',
      name: 'Brand name',
      industry: 'Industry / use case',
      industryPlaceholder: 'Example: Restaurant SaaS / QR Menu',
      tone: 'Tone',
      uploadLogo: 'Upload logo (extract colors)',
      logoDropTitle: 'Upload your logo',
      logoDropHint: 'Drop a PNG/SVG here or click Upload. Palette extraction happens locally in your browser.',
      hintPaletteLocal: 'Palette extracted locally in your browser.',
      hintLastLogo: 'Last logo: {{name}}',
      palette: 'Palette',
      noPalette: 'No palette yet. Upload a logo.',
      applyDefaults: 'Apply brand defaults',
      toneOptions: {
        professional: 'Professional',
        luxury: 'Luxury',
        playful: 'Playful',
        friendly: 'Friendly',
        bold: 'Bold',
      },
      logoInScene: 'Try to include logo in the scene (AI)',
      logoInSceneHint: 'Best-effort only; works best in non-proxy mode.',
      logoOverlayEnabled: 'Add exact logo overlay on download (images only)',
      logoOverlayPosition: 'Overlay position',
      logoOverlaySize: 'Overlay size (%)',
      logoOverlayOpacity: 'Overlay opacity (0–100)',
      logoOverlayPadding: 'Overlay padding (px)',
      logoOverlayPositions: {
        top_left: 'Top left',
        top_right: 'Top right',
        bottom_left: 'Bottom left',
        bottom_right: 'Bottom right',
        center: 'Center',
      },
    },
    variations: {
      title: 'Variations: {{loaded}}/{{total}} loaded',
      seedTitle: 'Seed {{seed}}',
      seedLabel: 'seed {{seed}}',
      loading: 'Loading',
      error: 'Error',
    },
    promptPreview: {
      copyPrompt: 'Copy prompt',
      copyNegative: 'Copy negative',
      negative: 'Negative',
      none: '—',
    },
    history: {
      saved: 'Saved in localStorage',
      memoryOnly: 'In-memory only',
      clear: 'Clear',
      noHistory: 'No history yet.',
      textResult: 'Text result',
      audio: 'Audio',
      historyAlt: 'History',
      metadataOnly: 'Request details only — result unavailable',
    },
    settings: {
      title: 'Settings',
      blockApp: 'App',
      collapse: 'Collapse settings',
      expand: 'Expand settings',
      usageTitle: 'Usage & cost',
      usagePerRun: 'Estimate: {{estimate}}',
      usageTotal: 'Session total (estimated): {{credits}} credits',
      usageDisclaimer: 'Estimates only. Actual billing/usage may differ.',
      apiKey: 'API key',
      apiKeyPlaceholder: 'Paste your key here',
      apiKeyHelp:
        'Missing API key. Add it in Settings → API key, or enable Settings → Network → Use server proxy.',
      apiKeyStatusProxy: 'Proxy enabled (server keeps the key secret)',
      apiKeyStatusLocalStorage: 'Using localStorage key (recommended for open-source demo)',
      apiKeyStatusEnv: 'Using .env key',
      apiKeyStatusNone: 'No key set yet',
      apiKeyDevProxyHint: 'Dev note: when proxy is enabled, set the API key in your server environment variables.',
      referenceUpload: 'Upload',
      referenceDropTitle: 'Add a reference image',
      referenceDropHint: 'Drop an image to match its colors/vibe. Used for style guidance.',
      referenceUploadHint: 'Pick mode in Settings → Reference image → Mode.',
      referencePreview: 'Preview',
      referenceExtractedPalette: 'Extracted palette',
      referenceEmpty: 'Upload an image to mimic its colors/vibe (and optionally use it as a strong reference).',
      checkKeyOrRetry: 'Check API key/model, or try Retry.',
      blockApiKey: 'API key',
      blockBrand: 'Brand',
      blockGeneration: 'Generation',
      modelsPrefix: 'Models: {{msg}}',
      referenceImage: 'Reference image',
      clientOnlyHint:
        'This is a client-only app (no proxy). Keys are visible in the browser and (if saved) stored in localStorage.',
      clearLocalKey: 'Clear local key',
      videoPaidOnlyNote:
        'Video is available in limited free mode. Paid-only models are disabled.',
      apiKeyDialogTitle: 'API key',
      apiKeyDialogConnected: 'Connected',
      apiKeyDialogNotConnected: 'Not connected',
      apiKeyDialogProxyNote: 'Proxy mode is enabled — the browser does not need a key.',
      apiKeyDialogOpen: 'Enter / manage key',
    },
    validation: {
      subjectRequired: 'Please describe what to generate (Subject).',
      strongRefProxyUnsupported:
        'Strong reference image is not supported in proxy mode yet. Use Reference mode = Style, or disable proxy.',
      videoModelsLoading: 'Video models are still loading. Wait a moment, then pick a video model (e.g. grok-video).',
      modelPaidOnly: 'Model "{{model}}" is marked paid_only. Choose another model.',
    },
    errors: {
      customSeedInvalid: 'Custom seed must be a non-negative integer.',
      modelsLoadFailed: 'Failed to load models',
      missingApiKey: 'Missing API key.',
      selectedModelNotVideo: 'Selected model is not a video model. Choose a video model (e.g. grok-video).',
      textModelsLoading: 'Text models are still loading. Wait a moment, then pick a text model.',
      audioModelsLoading: 'Audio models are still loading. Wait a moment, then pick an audio model.',
      brandKitIconGenerateFailed:
        'Brand kit: icon generation failed. If you see “Failed to fetch”, it’s usually CORS — enable Settings → Network → Use server proxy, or upload an icon manually.',
      brandKitLogoGenerateFailed:
        'Brand kit: logo generation failed. If you see “Failed to fetch”, it’s usually CORS — enable Settings → Network → Use server proxy, or upload a logo manually.',
    },
  },
  ar: {
    voice: {
      start: 'أملِ وصفك صوتياً', stop: 'إيقاف الإملاء', cancel: 'إلغاء الميكروفون', finishing: 'جارٍ الإنهاء…',
      languageLabel: 'لغة الإملاء',
      privacy: 'يستخدم خدمة الكلام في متصفحك، وقد تتم معالجة الصوت عبر الإنترنت.',
      unsupported: 'الإملاء الصوتي غير مدعوم في هذا المتصفح. جرّب Chrome أو Safari، أو استخدم إملاء جهازك.',
      starting: 'بانتظار السماح باستخدام الميكروفون…', listening: 'نستمع إليك… تحدّث ثم اضغط إيقاف الإملاء.',
      stopping: 'جارٍ إنهاء النص…', added: 'تمت إضافة كلامك. راجع الوصف قبل الإنشاء.',
      permission: 'لم يُسمح باستخدام الميكروفون. اسمح به من إعدادات الموقع في متصفحك ثم حاول مجدداً.',
      service: 'خدمة الكلام غير متاحة في هذا المتصفح. جرّب فتح الصفحة في Chrome أو Safari.',
      microphone: 'الميكروفون غير متاح. تحقّق من توصيله ومن أذونات النظام.',
      network: 'تعذّر الاتصال بخدمة الكلام في المتصفح. تحقّق من اتصالك أو جرّب Chrome أو Safari.',
      noSpeech: 'لم نلتقط أي كلام. حاول مجدداً وتحدّث بوضوح، أو تابع الكتابة.',
      language: 'خدمة الكلام لا تدعم اللغة المختارة. جرّب اللغة الأخرى أو تابع الكتابة.',
      startTimeout: 'تعذّر بدء الإملاء. تحقّق من إذن الميكروفون أو جرّب متصفحاً آخر.',
      failed: 'تعذّر بدء الإملاء الصوتي. حاول مجدداً أو تابع الكتابة.',
    },
    rewrite: {"action": "إعادة صياغة بالذكاء الاصطناعي", "busy": "جارٍ إعادة الصياغة…", "style": "أسلوب الصياغة", "polish": "تحسين", "shorten": "اختصار", "expand": "إضافة تفاصيل", "professional": "احترافي", "working": "نحسّن نصّك. سيبقى النص الأصلي كما هو.", "suggestion": "اقتراح الذكاء الاصطناعي", "review": "راجع الاقتراح أو عدّله، ثم اختر إن كنت تريد استخدامه.", "discard": "الاحتفاظ بالأصل", "apply": "استخدام هذه الصياغة", "error": "تعذّرت إعادة الصياغة الآن. حاول مجدداً. نصّك الأصلي لم يتغيّر."},
    studio: {
      "eyebrow": "فكرة صغيرة. احتمالات بلا حدود.",
      "title": "اصنع شيئاً",
      "titleAccent": "استثنائياً.",
      "description": "هويتك في كل تفصيلة. حوّل فكرتك إلى صور وفيديو وصوت وكلمات.",
      "activeBrand": "مساحة علامتك",
      "brief": "01 / الفكرة",
      "briefTitle": "ماذا سنبدع اليوم؟",
      "inspiration": "تحتاج إلى نقطة بداية؟",
      "characters": "حرف",
      "shortcut": "⌘ / Ctrl + Enter للإنشاء",
      "settings": "خصّص إعداداتك",
      "canvas": "مساحة الإبداع",
      "canvasCaption": "مساحة لفكرتك الكبيرة القادمة",
      "emptyTitle": "من شرارة إلى إبداع.",
      "emptyHint": "اكتب فكرتك وأضف لمستك ثم اضغط إنشاء. سيظهر عملك هنا.",
      "ready": "جاهزون لإبداعك",
      "brandAware": "هويتك في كل عمل",
      "exportReady": "جاهز للمشاركة",
      "historyEmpty": "بداية جديدة. ستجد أعمالك هنا.",
      "imageOne": "إبراز منتج",
      "imageTwo": "حملة اجتماعية",
      "imageThree": "مشهد تحريري",
      "videoOne": "كشف منتج",
      "videoTwo": "قصة العلامة",
      "videoThree": "مشهد سينمائي",
      "textOne": "منشور اجتماعي",
      "textTwo": "إطلاق منتج",
      "textThree": "قصة العلامة",
      "audioOne": "رسالة ترحيب",
      "audioTwo": "إعلان تشويقي",
      "audioThree": "تقديم العلامة",
      "promptDetails": "تفاصيل الوصف",
      "previewShortcut": "عرض العمل"
},
    app: {
      title: 'منشئ العلامة التجارية',
      subtitle: 'مشاريع كودفالكون • استوديو محتوى للعلامات التجارية',
      footer: 'صُنع بحب في سوريا • أحد مشاريع كودفالكون',
      heroKicker: 'أنشئ محتوى متناسقاً لعلامتك خلال دقائق',
      heroTitleA: 'اصنع أي شيء.',
      heroTitleB: 'وعزّز علامتك.',
      heroBody:
        'استوديو متكامل للصور والفيديو والصوت والنص. ارفع شعارك لاستخراج لوحة الألوان وصدّر الصور مع طبقة شعار ثابتة.',
    },
    common: {
      language: 'اللغة',
      mediaType: 'نوع المحتوى',
      upload: 'رفع',
      toggleTheme: 'تبديل المظهر',
      edit: 'تعديل',
      remove: 'إزالة',
      back: 'رجوع',
      close: 'إغلاق',
      open: 'فتح',
      preview: 'معاينة',
      retry: 'إعادة المحاولة',
      download: 'تنزيل',
      downloadAll: 'تنزيل الكل (ZIP)',
      loading: 'جارٍ التحميل',
      error: 'خطأ',
      generate: 'إنشاء',
      generating: 'جارٍ الإنشاء…',
      settings: 'الإعدادات',
      seed: 'الطابع',
      copy: 'نسخ',
      copyUrl: 'نسخ الرابط',
      copyOutput: 'نسخ المخرجات',
      copyText: 'نسخ النص',
      save: 'حفظ',
      clear: 'مسح',
    },
    media: { image: 'صورة', video: 'فيديو', text: 'نص', audio: 'صوت' },
    nav: {
      pages: 'الصفحات',
      studio: 'الاستوديو',
      brandKit: 'حزمة العلامة',
    },
    tabs: {
      prompt: 'الوصف',
      history: 'السجل ({{count}})',
    },
      brandKit: {
        title: 'حزمة العلامة',
        subtitle: 'ابنِ هوية علامتك ثم أنشئ حزمة كاملة للسوشيال.',
        stepsLabel: 'خطوات حزمة العلامة',
        settingsTabs: {
          identity: 'الهوية',
          pack: 'الحزمة',
        },
        steps: {
          basics: 'الأساسيات',
          studio: 'استوديو التصميم',
          export: 'التصدير',
        },
        basics: {
          title: 'أساسيات العلامة',
        },
        logo: {
          title: 'الشعار',
          ready: 'الشعار جاهز. ستبقى الألوان متناسقة عبر كل الأصول.',
          missing: 'ارفع شعاراً لتفعيل استخراج الألوان والطبقات.',
          generate: 'توليد شعار',
          generating: 'جارٍ توليد الشعار…',
        },
        identity: {
          previewTitle: 'معاينة',
          colorsTitle: 'الألوان',
          colorsHint: 'يمكنك تعديل أو توسيع هذه اللوحة لاحقاً.',
          fontsTitle: 'الخطوط',
        colorPicker: 'منتقي اللون',
        colorHex: 'كود اللون',
        addColor: 'إضافة لون',
        colorMode: 'وضع الألوان',
        modeDark: 'داكن',
        modeLight: 'فاتح',
        regenFromPalette: 'توليد الأدوار تلقائياً',
        rolesTitle: 'أدوار الألوان',
        rolesMissing: 'لم يتم إعداد الأدوار بعد. اضغط توليد الأدوار تلقائياً.',
        locked: 'مقفول',
        unlocked: 'مفتوح',
        roleBackground: 'الخلفية',
        roleSurface: 'سطح',
        rolePrimary: 'أساسي',
        roleSecondary: 'ثانوي',
        roleAccent: 'إبراز',
        roleText: 'النص',
        roleTextMuted: 'نص خافت',
        roleBorder: 'حدود',
        roleTextOnPrimary: 'نص على الأساسي',
        contrastBg: 'نص/خلفية',
        contrastSurface: 'نص/سطح',
        contrastPrimary: 'نص/أساسي',
        previewText: 'معاينة لواجهة علامتك. عدّل الأدوار حتى تصبح مناسبة.',
        primaryButton: 'زر أساسي',
        secondaryButton: 'زر ثانوي',
        fontArabic: 'خط عربي',
        fontLatin: 'خط لاتيني',
        fontsHint: 'اختر زوج خطوط للحفاظ على الاتساق.',
      },
        pack: {
          title: 'حزمة السوشيال',
          previewTitle: 'معاينة',
          hint: 'نصيحة: ابدأ بصورة شخصية + 6 أغلفة هايلايت.',
          livePreviewTitle: 'معاينة انستغرام مباشرة',
          liveHint: 'اضغط على الصورة الشخصية أو اسم الحساب أو النبذة أو الهايلايت أو مربعات الشبكة للتعديل.',
          liveOpenPreview: 'فتح المعاينة',
          liveReset: 'إعادة الضبط',
          liveEditTitle: 'تعديل الصورة',
          liveEditTextTitle: 'تعديل النص',
          brandSettingsTitle: 'إعدادات العلامة',
          liveInspectorTitle: 'محرر مباشر',
          liveInspectorEmpty: 'اضغط على عنصر في المعاينة لتعديله.',
          liveEditNow: 'تعديل',
          liveEditPick: 'تعديل (اضغط عنصر)',
          liveUpload: 'رفع',
          liveGenerateAi: 'توليد بالذكاء',
          liveGenerateTextAi: 'توليد نص بالذكاء',
          livePromptLabel: 'الوصف',
          livePromptPlaceholder: 'صف ما تريد… (بدون نص/حروف)',
          livePromptReset: 'إعادة الوصف',
          livePromptHint: 'استخدم القوالب لنتيجة سريعة. استخدم المخصص فقط عند الحاجة.',
          livePromptCustom: 'مخصص',
          livePromptUsePresets: 'استخدام القوالب',
          livePreset: {
            default: 'افتراضي',
            minimal: 'بسيط',
            illustration: 'رسومي',
            luxury: 'فاخر',
            playful: 'مرح',
          },
          livePickAvatar: 'تغيير الصورة الشخصية',
          livePickProfileName: 'تعديل اسم الحساب',
          livePickBio: 'تعديل النبذة',
          livePickHighlight: 'تغيير غلاف الهايلايت: {{label}}',
          livePickGrid: 'تغيير مربع {{index}}',
          livePickCaption: 'تعديل وصف منشور {{index}}',
          liveNoHighlights: 'أنشئ أغلفة الهايلايت لتعديلها هنا.',
          liveTextValue: 'النص',
          liveCaption: 'وصف المنشور',
          liveCaptionPlaceholder: 'اكتب وصفاً…',
          liveGenerateCaptionAi: 'توليد وصف',
          liveDone: 'تم',
          includeAvatar: 'الصورة الشخصية',
          includeHighlights: 'أغلفة هايلايت انستغرام',
          includePosts: 'منشورات انستغرام',
          postsTitle: 'المنشورات',
          postCount: 'العدد',
          generateCaptions: 'توليد أوصاف المنشورات',
          postTopics: 'مواضيع المنشورات',
          postTopicsPlaceholder: 'موضوع لكل سطر…',
          postTopicsHint: 'سيتم استخدام أول الأسطر كمواضيع لكل منشور (يتم تجاهل الزائد).',
          generatePostsAi: 'توليد منشورات بالذكاء الاصطناعي',
          artStyle: 'نمط الهايلايت',
          artIllustration: 'رسمة',
          artSubLogo: 'شعار فرعي',
          highlightLabels: 'عناوين الهايلايت',
          addLabel: 'إضافة عنوان',
          labelPlaceholder: 'عنوان',
          bilingualHint: 'استخدم “English | عربي” لتحديد اللغتين لعنوان واحد.',
          langEnglish: 'مجموعة إنجليزية',
          langArabic: 'مجموعة عربية',
          regenerateIcons: 'إعادة توليد الأيقونات',
          generateIcon: 'توليد رسمة',
          generateSubLogo: 'توليد شعار فرعي',
          uploadIcon: 'رفع صورة',
          iconBackdrop: 'خلفية الأيقونة',
          backdropTransparent: 'شفافة',
          backdropSurface: 'سطح',
          backdropPrimary: 'أساسي',
        backdropAccent: 'إبراز',
        backdropCustom: 'مخصصة',
        backdropOpacity: 'شفافية الخلفية',
        generate: 'إنشاء الحزمة',
        viewExport: 'عرض التصدير',
      },
      export: {
        title: 'التصدير',
        empty: 'أنشئ الحزمة لعرض الأصول هنا.',
        exportAll: 'تصدير الكل',
      },
      assets: {
        avatar: 'صورة شخصية',
        post: 'منشور {{index}}',
        caption: 'وصف {{index}}',
      },
    },
    promptCard: {
      title: 'الوصف',
      hintImage: 'صف ما تريد. الباقي يتم توليده من إعداداتك.',
      hintText: 'اطلب ما تريد كتابته. سيتم تطبيق العلامة/الإعدادات تلقائياً.',
      hintAudio: 'اكتب النص الذي تريد نطقه. الصوت/النموذج من الإعدادات.',
      fieldLabelImage: 'ماذا تريد أن تُنشئ؟',
      fieldLabelText: 'التعليمات',
      fieldLabelAudio: 'النص المراد نطقه',
      placeholderImage: 'مثال: مشهد مطعم حديث، عميل يمسح QR لقائمة الطعام، إضاءة سينمائية',
      placeholderText: 'مثال: اكتب نص ريلز 20 ثانية عن SaaS لقائمة مطعم QR، باللغة العربية.',
      placeholderAudio: 'مثال: حوّل قائمة مطعمك إلى QR Menu خلال 24 ساعة',
    },
    generation: {
      eyebrow: 'فكرة صغيرة تأخذ شكلها',
      image: 'جارٍ إنشاء صورتك',
      video: 'جارٍ إنشاء الفيديو',
      audio: 'جارٍ إنشاء الصوت',
      text: 'جارٍ كتابة نصّك',
      imageHint: 'نحوّل فكرتك إلى صورة بتكوين وألوان تناسبها.',
      videoHint: 'الحركة المتقنة تحتاج وقتاً. قد يستغرق الفيديو بضع دقائق.',
      audioHint: 'نحوّل وصفك إلى صوت. سيظهر المقطع هنا عندما يجهز.',
      textHint: 'نصيغ الكلمات بما يناسب فكرتك وهوية علامتك.',
      longWait: 'استغرق الطلب وقتاً أطول. ما زلنا بانتظار النتيجة، لا داعي للإنشاء مجدداً.',
      inProgress: 'الإنشاء قيد التنفيذ',
      elapsed: 'الوقت المنقضي: {{time}}',
      keepOpen: 'أبقِ هذه الصفحة مفتوحة. ستظهر النتيجة هنا تلقائياً.',
      viewProgress: 'تابع التقدّم في المعاينة',
      failed: 'تعذّر إكمال الإنشاء',
    },
    preview: {
      lockSeed: 'تثبيت الطابع',
      generatedAlt: 'تم الإنشاء',
      loadingTitle: 'جارٍ الإنشاء…',
      textFailedTitle: 'فشل إنشاء النص',
      loadFailedTitleImage: 'فشل تحميل الصورة',
      loadFailedTitleVideo: 'فشل تحميل الفيديو',
      loadFailedTitleAudio: 'فشل تحميل الصوت',
      emptyTitleImage: 'ستظهر المعاينة هنا',
      emptyTitleText: 'سيظهر ناتج النص هنا',
      emptyTitleAudio: 'سيظهر ناتج الصوت هنا',
      emptyHint: 'املأ الوصف ثم اضغط إنشاء.',
      videoWaitHint: 'قد يستغرق الفيديو 1–3 دقائق.',
      logoOverlayAdd: 'إضافة الشعار',
      logoOverlayRemove: 'إزالة الشعار',
      logoOverlayTitle: 'طبقة الشعار',
      instagramOn: 'معاينة انستغرام',
      instagramOff: 'معاينة عادية',
      instagramHint: 'أضف وصفاً في Subject لعرضه هنا.',
      instagramProfile: 'الملف',
      instagramPost: 'منشور',
      instagramStory: 'ستوري',
    },
    brand: {
      profile: 'ملف العلامة',
      newBrand: 'علامة جديدة',
      untitled: 'علامة بدون اسم',
      useProfile: 'استخدام ملف العلامة (ألوان + اتساق الأسلوب)',
      new: 'جديد',
      name: 'اسم العلامة',
      industry: 'المجال / الاستخدام',
      industryPlaceholder: 'مثال: نظام مطاعم / قائمة QR',
      tone: 'النبرة',
      uploadLogo: 'رفع الشعار (استخراج الألوان)',
      logoDropTitle: 'ارفع شعارك',
      logoDropHint: 'اسحب ملف PNG/SVG هنا أو اضغط رفع. يتم استخراج لوحة الألوان محلياً داخل المتصفح.',
      hintPaletteLocal: 'يتم استخراج الألوان محلياً داخل المتصفح.',
      hintLastLogo: 'آخر شعار: {{name}}',
      palette: 'لوحة الألوان',
      noPalette: 'لا توجد ألوان بعد. ارفع شعاراً.',
      applyDefaults: 'تطبيق إعدادات العلامة الافتراضية',
      toneOptions: {
        professional: 'احترافية',
        luxury: 'فاخرة',
        playful: 'مرحة',
        friendly: 'ودّية',
        bold: 'جريئة',
      },
      logoInScene: 'محاولة تضمين الشعار داخل المشهد (AI)',
      logoInSceneHint: 'محاولة فقط (غير مضمون)؛ يعمل أفضل بدون وضع الوكيل.',
      logoOverlayEnabled: 'إضافة الشعار كطبقة ثابتة عند التنزيل (للصور فقط)',
      logoOverlayPosition: 'موضع الشعار',
      logoOverlaySize: 'حجم الشعار (%)',
      logoOverlayOpacity: 'شفافية الشعار (0–100)',
      logoOverlayPadding: 'هامش الشعار (px)',
      logoOverlayPositions: {
        top_left: 'أعلى يسار',
        top_right: 'أعلى يمين',
        bottom_left: 'أسفل يسار',
        bottom_right: 'أسفل يمين',
        center: 'الوسط',
      },
    },
    variations: {
      title: 'تنويعات: تم تحميل {{loaded}}/{{total}}',
      seedTitle: 'البذرة {{seed}}',
      seedLabel: 'البذرة {{seed}}',
      loading: 'جارٍ التحميل',
      error: 'خطأ',
    },
    promptPreview: {
      copyPrompt: 'نسخ الوصف',
      copyNegative: 'نسخ السلبي',
      negative: 'السلبي',
      none: '—',
    },
    history: {
      saved: 'محفوظ في localStorage',
      memoryOnly: 'في الذاكرة فقط',
      clear: 'مسح',
      noHistory: 'لا يوجد سجل بعد.',
      textResult: 'ناتج نصي',
      audio: 'صوت',
      historyAlt: 'السجل',
      metadataOnly: 'تفاصيل الطلب فقط — النتيجة غير متاحة',
    },
    settings: {
      title: 'الإعدادات',
      blockApp: 'التطبيق',
      collapse: 'طي الإعدادات',
      expand: 'فتح الإعدادات',
      usageTitle: 'الاستخدام والتكلفة',
      usagePerRun: 'تقدير: {{estimate}}',
      usageTotal: 'إجمالي الجلسة (تقريبي): {{credits}} رصيد',
      usageDisclaimer: 'هذه تقديرات فقط وقد تختلف عن الاستخدام/الفوترة الفعلية.',
      apiKey: 'مفتاح API',
      apiKeyPlaceholder: 'الصق المفتاح هنا',
      apiKeyHelp:
        'مفتاح API غير موجود. أضِفه من الإعدادات ← مفتاح API، أو فعّل الإعدادات ← الشبكة ← استخدام وكيل الخادم.',
      apiKeyStatusProxy: 'الوكيل مفعّل (الخادم يُخفي المفتاح)',
      apiKeyStatusLocalStorage: 'استخدام مفتاح localStorage (مُوصى به لنسخة العرض)',
      apiKeyStatusEnv: 'استخدام مفتاح .env',
      apiKeyStatusNone: 'لم يتم تعيين مفتاح بعد',
      apiKeyDevProxyHint: 'ملاحظة التطوير: عند تفعيل الوكيل، عيّن مفتاح API ضمن متغيرات بيئة الخادم.',
      referenceUpload: 'رفع',
      referenceDropTitle: 'أضف صورة مرجعية',
      referenceDropHint: 'اسحب صورة لمطابقة ألوانها/أجوائها. تُستخدم لإرشاد الأسلوب.',
      referenceUploadHint: 'اختر الوضع من الإعدادات ← صورة مرجعية ← الوضع.',
      referencePreview: 'معاينة',
      referenceExtractedPalette: 'لوحة ألوان مستخرجة',
      referenceEmpty: 'ارفع صورة لمطابقة ألوانها/أجوائها (ويمكن استخدامها كمرجع قوي).',
      checkKeyOrRetry: 'تحقق من المفتاح/النموذج أو جرّب إعادة المحاولة.',
      blockApiKey: 'مفتاح API',
      blockBrand: 'العلامة',
      blockGeneration: 'الإنشاء',
      modelsPrefix: 'النماذج: {{msg}}',
      referenceImage: 'صورة مرجعية',
      clientOnlyHint: 'هذا تطبيق يعمل على المتصفح فقط (بدون وكيل). المفاتيح تظهر في المتصفح وتُحفظ (إن حفظتها) في localStorage.',
      clearLocalKey: 'مسح المفتاح المحلي',
      videoPaidOnlyNote: 'الفيديو متاح بوضع مجاني محدود. النماذج الموسومة paid_only ستكون معطّلة.',
      apiKeyDialogTitle: 'مفتاح API',
      apiKeyDialogConnected: 'متصل',
      apiKeyDialogNotConnected: 'غير متصل',
      apiKeyDialogProxyNote: 'وضع الوكيل مفعّل — المتصفح لا يحتاج مفتاحاً.',
      apiKeyDialogOpen: 'إدخال / إدارة المفتاح',
    },
    schema: {
      section: {
        subject: 'الموضوع',
        brand: 'العلامة',
        output: 'المخرجات',
        network: 'الشبكة',
        creative: 'الإبداع',
        reference: 'صورة مرجعية',
        overlay: 'نص على الصورة (اختياري)',
        constraints: 'قيود',
        storage: 'التخزين',
      },
      field: {
        subject: {
          label: 'ماذا تريد أن تُنشئ؟',
          placeholder: 'مثال: زجاجة عطر فاخرة على طاولة رخامية مع ظلال ناعمة',
        },
        useBrandProfile: { label: 'استخدام ملف العلامة (ألوان + اتساق الأسلوب)' },
        brandId: { label: 'ملف العلامة' },
        brandConsistency: { label: 'درجة الاتساق' },
        mediaType: { label: 'النوع' },
        platformPreset: { label: 'القالب' },
        width: { label: 'العرض' },
        height: { label: 'الارتفاع' },
        model: { label: 'النموذج' },
        duration: { label: 'المدة (ثوانٍ)' },
        aspectRatio: { label: 'نسبة الأبعاد' },
        audio: { label: 'صوت (إن كان مدعوماً)' },
        voice: { label: 'الصوت' },
        seedMode: { label: 'البذرة' },
        seedValue: { label: 'بذرة مخصصة', placeholder: 'مثال: 123456' },
        variations: { label: 'عدد التنويعات' },
        useProxy: { label: 'استخدام وكيل الخادم (إخفاء المفتاح عند النشر)' },
        contentPreset: { label: 'نوع المحتوى' },
        stylePreset: { label: 'الأسلوب' },
        lightingPreset: { label: 'الإضاءة' },
        compositionPreset: { label: 'التكوين' },
        palettePreset: { label: 'لوحة الألوان' },
        moodPreset: { label: 'المزاج' },
        scene: { label: 'المشهد (اختياري)', placeholder: 'مثال: مطعم حديث، حامل QR على الطاولة، عميل يمسح بالهاتف' },
        beats: { label: 'لقطات الكاميرا (اختياري)', placeholder: 'مثال: لقطة مقرّبة → مسح QR → شاشة القائمة → ابتسامة المالك' },
        background: { label: 'الخلفية (اختياري)', placeholder: 'مثال: خلفية بيضاء نظيفة، أضواء مدينة ضبابية' },
        camera: { label: 'ملاحظات الكاميرا (اختياري)', placeholder: 'مثال: 85mm، عمق مجال ضحل، f/1.8' },
        referenceMode: { label: 'الوضع' },
        referenceImageDataUrl: { label: 'رفع صورة' },
        overlayText: { label: 'نص على الصورة (اختياري)', placeholder: 'ملاحظة: النص داخل الصور قد لا يكون دقيقاً؛ يمكنك طلب مساحة فارغة وإضافة النص لاحقاً.' },
        overlayLanguage: { label: 'اللغة' },
        overlayPosition: { label: 'الموضع' },
        overlayStyle: { label: 'الأسلوب' },
        allowText: { label: 'السماح بالنص/الخط داخل الصورة' },
        avoidLogos: { label: 'تجنّب الشعارات/العلامات' },
        safe: { label: 'الوضع الآمن' },
        enhance: { label: 'تحسين (إن كان مدعوماً)' },
        transparent: { label: 'خلفية شفافة (إن كان مدعوماً)' },
        quality: { label: 'الجودة' },
        negativePromptExtra: { label: 'وصف سلبي (إضافي)', placeholder: 'مثال: نص، علامة مائية، شعار، ضبابية، جودة منخفضة' },
        persistHistory: { label: 'حفظ السجل في localStorage' },
        historyLimit: { label: 'حد السجل' },
      },
      option: {
        brandConsistency: {
          low: 'منخفض (إبداع أكثر)',
          medium: 'متوسط',
          high: 'عالٍ (اتساق أكثر)',
        },
        mediaType: {
          image: 'صورة',
          video: 'فيديو',
          text: 'نص',
          audio: 'صوت (تحويل نص إلى كلام)',
        },
        aspectRatio: {
          '9x16': '9:16 (ريلز/ستوري)',
          '16x9': '16:9 (عريض)',
          '1x1': '1:1 (مربع)',
        },
        seedMode: {
          random: 'عشوائي (كل مرة جديد)',
          custom: 'مخصص (مثبّت)',
        },
        referenceMode: {
          off: 'إيقاف',
          style: 'محاكاة الأسلوب (ألوان + إحساس)',
          strong: 'مطابقة قوية (استخدام الصورة كمرجع)',
        },
        overlayLanguage: {
          auto: 'تلقائي',
          ar: 'العربية',
          en: 'الإنجليزية',
        },
        overlayPosition: {
          top: 'أعلى',
          center: 'الوسط',
          bottom: 'أسفل',
          left: 'يسار',
          right: 'يمين',
        },
        overlayStyle: {
          clean_bold: 'نظيف + عريض',
          minimal: 'بسيط',
          luxury: 'فاخر',
          playful: 'مرح',
        },
        quality: {
          low: 'منخفضة',
          medium: 'متوسطة',
          high: 'عالية',
        },
      },
    },
    validation: {
      subjectRequired: 'يرجى وصف ما تريد إنشاءه (الموضوع).',
      strongRefProxyUnsupported:
        'الصورة المرجعية القوية غير مدعومة مع وضع الوكيل حالياً. استخدم وضع المرجع = الأسلوب أو عطّل الوكيل.',
      videoModelsLoading: 'نماذج الفيديو ما زالت تُحمّل. انتظر قليلاً ثم اختر نموذج فيديو (مثل grok-video).',
      modelPaidOnly: 'النموذج "{{model}}" موسوم paid_only. اختر نموذجاً آخر.',
    },
    errors: {
      customSeedInvalid: 'يجب أن تكون البذرة المخصصة رقماً صحيحاً غير سالب.',
      modelsLoadFailed: 'فشل تحميل النماذج',
      missingApiKey: 'مفتاح API غير موجود.',
      selectedModelNotVideo: 'النموذج المختار ليس نموذج فيديو. اختر نموذج فيديو (مثل grok-video).',
      textModelsLoading: 'نماذج النص ما زالت تُحمّل. انتظر قليلاً ثم اختر نموذجاً.',
      audioModelsLoading: 'نماذج الصوت ما زالت تُحمّل. انتظر قليلاً ثم اختر نموذجاً.',
      brandKitIconGenerateFailed:
        'حزمة العلامة: فشل توليد الأيقونة. إذا ظهرت “Failed to fetch” فعادةً السبب CORS — فعّل الإعدادات → الشبكة → استخدام البروكسي، أو ارفع أيقونة يدوياً.',
      brandKitLogoGenerateFailed:
        'حزمة العلامة: فشل توليد الشعار. إذا ظهرت “Failed to fetch” فعادةً السبب CORS — فعّل الإعدادات → الشبكة → استخدام البروكسي، أو ارفع شعاراً يدوياً.',
    },
  },
};
